<div class="flex-container gap-6" style="height: 100%">
  <div class="flex-col" style="gap: 1px">
    <vl-widget-title
      [text]="customTitle() ?? ('dashboard_ui.repartition_ca' | trans)"
      [accent]="caTotal()"
      [widget]="widget()"
      [draggable]="!!widget()"
      [info]="'dashboard_ui.repartition_ca_info' | trans"
    >
      <ng-content class="drag-handler" select='.drag-handler'></ng-content>
      <vl-chips-toggle [elements]="groupByElements()" [(value)]="groupBy" size="small"/>
      @if (!hidePeriod()) {
        <mat-icon class="cursor-pointer on-disabled shrink-0" [matMenuTriggerFor]="periodMenu" style="font-size: 20px; width: 20px; height: 20px">tune</mat-icon>
      }
    </vl-widget-title>
    @if (margeLabel()) {
      <span class="caption on-disabled" style="padding-left: 40px">{{ margeLabel() }}</span>
    }
  </div>

  @if (metadata()?.loading) {
    <div class="h100 flex-row gap-16 widget-content">
      <div>
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{'height': '180px', 'width': '180px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader count="8" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else if (activeData()?.length) {
    <div class="flex-row w100 widget-content fade-in" style="overflow: hidden">
      <div class="h100 overflow-hidden grow" style="min-width: 0">
        <canvas #repart></canvas>
      </div>
      <div class="flex-col shrink-0 justify-between" style="max-width: 180px; overflow: hidden; padding-top: 8px">
        <div class="flex-col gap-2 mt-8">
          @if (labels()) {
            @for(label of labels(); track label.label) {
              <div class="flex-row gap-4 p-2 align-center">
                <span [style.background-color]="label.color" class="border-full shrink-0" style="width: 8px; height: 8px"></span>
                <span class="grow tiny on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{label.label}}</span>
                <span class="tiny on-disabled shrink-0">{{label.percentage}}%</span>
              </div>
            }
          }
        </div>
        <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>

<!-- Period filter menu -->
<mat-menu #periodMenu="matMenu" class="fit-content-menu">
  <div class="p-12 flex-col gap-12" (click)="$event.stopPropagation()">
    <div class="flex-col gap-8">
      <span class="caption on-disabled">{{ 'dashboard_ui.echelle' | trans }}</span>
      <vl-chips-toggle [elements]="periodElements" [(value)]="period" size="small"/>
    </div>
    <div class="flex-row gap-8 align-center justify-between">
      <div class="flex-col" style="gap: 2px">
        <span class="caption">Inclure la main-d'œuvre</span>
        <span class="tiny on-disabled">Décoche pour une marge calculée uniquement sur les composants</span>
      </div>
      <mat-slide-toggle
        [checked]="includeMO()"
        (change)="includeMO.set($event.checked)"
        color="primary"/>
    </div>
    <div class="flex-row gap-8 align-center justify-between">
      <div class="flex-col" style="gap: 2px">
        <span class="caption">Inclure la remise pied</span>
        <span class="tiny on-disabled">Décoche pour voir le CA brut (avant remise pied de facture)</span>
      </div>
      <mat-slide-toggle
        [checked]="includeRemisePied()"
        (change)="includeRemisePied.set($event.checked)"
        color="primary"/>
    </div>
  </div>
</mat-menu>
